export const PROFIT_EXCHANGE_RATE_EN = 1 / 1200;
export const PROFIT_EXCHANGE_RATE_JP = 100 / 850;

export const DIGIT = 2;
